/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Laps_Row_No_Distance_HintInputs */

const en_ui_laps_row_no_distance_hint = /** @type {(inputs: Ui_Laps_Row_No_Distance_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This session has no distance data`)
};

const de_ui_laps_row_no_distance_hint = /** @type {(inputs: Ui_Laps_Row_No_Distance_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Einheit hat keine Distanzdaten`)
};

/**
* | output |
* | --- |
* | "This session has no distance data" |
*
* @param {Ui_Laps_Row_No_Distance_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_row_no_distance_hint = /** @type {((inputs?: Ui_Laps_Row_No_Distance_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Row_No_Distance_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_row_no_distance_hint(inputs)
	return de_ui_laps_row_no_distance_hint(inputs)
});